<template>
  <div class="navbar-options">
    <!-- Shortcuts button -->
    <div class="navbar-button-container">
      <navbar-button title="Shortcuts" @click="openShortcuts">
        <keyboard-icon color="white" :width="32" :height="32" />
      </navbar-button>
    </div>

    <!-- Notifications button -->
    <div class="navbar-button-container">
      <navbar-button
        title="Notifications"
        :class="{ unread: isNewNotif }"
        @click="openNotifs"
      >
        <notifications-icon
          :color="isNewNotif ? 'black' : 'white'"
          :width="28"
          :height="28"
        />
      </navbar-button>
    </div>
  </div>
</template>

<script>
import NavbarButton from "@/components/navbar/NavbarButton.vue";
import KeyboardIcon from "@/components/icons/KeyboardIcon.vue";
import NotificationsIcon from "@/components/icons/NotificationsIcon.vue";

// @group Navbar
// Navbar additional actions
export default {
  name: "NavbarOptions",
  components: {
    NavbarButton,
    KeyboardIcon,
    NotificationsIcon
  },
  props: {
    /** new notification received flag */
    isNewNotif: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // @vuese
    // Open shortcuts list
    openShortcuts() {
      this.$emit("shortcuts");
    },
    // @vuese
    // Open notifications panel
    openNotifs() {
      this.$emit("notifs");
    }
  }
};
</script>

<style scoped>
.navbar-options {
  display: flex;
}

/** Desktop */
@media only screen and (min-width: 992px) {
  .navbar-button-container {
    margin-top: 10px;
    margin-bottom: 5px;
    margin-left: 15px;
    justify-self: flex-end;
  }
  .navbar-button-container:not(:last-child) {
    margin-right: 15px;
  }
  .navbar-icon {
    font-size: 25px;
  }
  .navbar-button-container .unread {
    background-color: #e7c01f;
  }
}

/** Mobile */
@media only screen and (max-width: 991px) {
  .navbar-options {
    width: 100%;
    justify-content: space-between;
  }
  .navbar-button-container {
    width: 100%;
    margin: 10px;
    display: flex;
  }
  .navbar-icon {
    font-size: 22px;
    margin-top: 7px;
  }
}
</style>
